export const dynamicProfilesEndpoint = state => `${state.config.apiUrl}/v1/dynamic-profiles`;
export const dynamicProfileSingleEndpoint = (state, payload) => `${state.config.apiUrl}/v1/dynamic-profiles/${payload.dynamicProfileId}`;



// WEBPACK FOOTER //
// ./src/services/dynamicProfiles/selectors.js